import { render, staticRenderFns } from "./activity-upload-video.vue?vue&type=template&id=5b93baae&scoped=true&"
import script from "./activity-upload-video.vue?vue&type=script&lang=js&"
export * from "./activity-upload-video.vue?vue&type=script&lang=js&"
import style0 from "./activity-upload-video.vue?vue&type=style&index=0&id=5b93baae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b93baae",
  null
  
)

export default component.exports